import type { BlockViewProps } from '@plone/types';

import Body from 'iovisit-reggioemiliawelcome/components/Blocks/EmbedTrekksoft/Body';
import type { EmbedTrekksoftData } from 'iovisit-reggioemiliawelcome/components/Blocks/EmbedTrekksoft/schema';
type EmbedTrekksoftViewProps = Omit<BlockViewProps, 'data'> & {
  data: EmbedTrekksoftData;
};

const View = (props: EmbedTrekksoftViewProps) => {
  const { data, properties } = props;
  return (
    <div className="block embed-trekksoft-block public-ui">
      <Body content={properties} data={data} />
    </div>
  );
};

export default View;
